import { UserManager, WebStorageStateStore } from "oidc-client";

const authority = process.env.REACT_APP_AUTHENTICATION_AUTHORITY || "https://identity.hc.alpha-cr.com";
const appName = process.env.REACT_APP_APP_NAME || "prebiller-app";
const callbackBase = process.env.REACT_APP_AUTHENTICATION_CALLBACK || window.location.origin;

// Sin metadata override: oidc-client descubre el well-known automáticamente.
// El Identity Server devuelve issuer:"null" en well-known Y en el claim iss del JWT,
// por lo que la validación coincide correctamente sin intervención manual.
// automaticSilentRenew desactivado porque prompt=none falla en el servidor (→ /home/error).
const userManager = new UserManager({
    authority,
    client_id: appName,
    redirect_uri: `${callbackBase}/authentication/login-callback`,
    post_logout_redirect_uri: `${callbackBase}/authentication/logout-callback`,
    silent_redirect_uri: `${callbackBase}/silent_renew`,
    response_type: "code",
    scope: "openid profile IdentityServerApi protocolsapi databaseapi agendaapi notificationsapi medicalrecordapi digitalsignapi pre_biller_app",
    automaticSilentRenew: false,
    // monitorSession produce un iframe oculto al check_session_endpoint del OP.
    // Combinado con prompt=none roto en el servidor genera /home/error 500.
    monitorSession: false,
    // @ts-ignore – monitorAnonymousSession exists at runtime but is missing from the type defs
    monitorAnonymousSession: false,
    loadUserInfo: true,
    userStore: new WebStorageStateStore({ prefix: appName }),
    clockSkew: 900,
});

export default userManager;
